module.exports = __webpack_public_path__ + "img/adTwo.6a447b81.png";